<template>
    <div :class="$style['splash-css']">
        <img :class="$style['paddB']" src="../assets/image/cluna/splash.png" alt=""/>
    </div>
</template>
<script>
    export default {
        name: "splash",
        data() {
            return {}
        },
        mounted() {
            setTimeout(() => {
                this.$router.push("main");
            }, 1000);
        },
    };
</script>
<style module>
    .splash-css {
        height: 100%;
        width: 100%;
        background-color: #7fc452;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .splash-css .imageSplash {
        height: 100px;
        width: 100px;
        opacity: 0;
        animation: mymove 5s infinite;
    }

    .splash-css .paddB {
        margin-bottom: 20px;
    }

    .splash-css img {
        height: 100%;
        width: 100%;
        object-fit: contain;
    }

    @keyframes mymove {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
</style>
